import React from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { RoomFilterData } from '@/services/optionGroups';
import { FilterDropDown } from '@ygtechnologies/bygr-frontend-component-library';

interface RoomFilterProps {
    value?: number[];
    rooms?: RoomFilterData[];

    onChange: (value: number[]) => void;
}

export const RoomFilter: React.FC<RoomFilterProps> = ({ value = [], onChange, rooms = [] }) => {
    return (
        <FilterDropDown
            placeholder={t`Any room`}
            label={<Trans>Rooms</Trans>}
            data={rooms}
            value={value}
            onChange={(v) => onChange(v.map((x) => x.id))}
        />
    );
};
